import http from '@/utils/http'

export default {
  contractCompleteOrders: data => http({ url: '/api/admin/v1/yeepayPayment/contractCompleteOrders', data }),
  contractCompleteOptions: data => http({ url: '/api/admin/v1/yeepayPayment/contractCompleteOptions', data }),
  contractCompleteCreate: data => http({ url: '/api/admin/v1/yeepayPayment/contractCompleteCreate', data, tip: true }),
  contractInstantOptions: data => http({
    url: '/api/admin/v1/yeepayPayment/contractInstantOptions',
    data,
  }),
  contractInstantCreate: data => http({
    url: '/api/admin/v1/yeepayPayment/contractInstantCreate',
    data,
    tip: true,
  }),
  status: data => http({
    url: '/api/admin/v1/yeepayPayment/status',
    data,
  }),
  statusByPaymentNo: data => http({
    url: '/api/admin/v1/yeepayPayment/statusByPaymentNo',
    data,
  }),
  syncStatus: data => http({
    url: '/api/admin/v1/yeepayPayment/syncStatus',
    data,
  }),
}
